import { useEffect, useState } from 'react';
import { useLogo } from 'src/easyclaim.app.hooks/useLogo';
import { reportError } from 'src/easyclaim.app.libs/reportError';
import { EasyClaimDocumentService } from 'src/easyclaim.app.services';

export interface LogoImageProps {
	caseId: string;
	documentService: EasyClaimDocumentService;
}

export function LogoImage({ caseId, documentService }: LogoImageProps) {
	const [logoUrl, setLogoUrl] = useState<string>('');
	const { logo, isEnabled } = useLogo({ caseId, enabled: !!caseId });

	useEffect(() => {
		if (isEnabled) {
			return;
		}

		const fetchLegacyLogo = async () => {
			try {
				const url = await documentService.getLogoAnyFormat(caseId);

				setLogoUrl(url);
			} catch (error) {
				reportError(error, { context: 'LogoImage.fetchLegacyLogo', caseId });
				setLogoUrl('');
			}
		};

		void fetchLegacyLogo();
	}, [caseId, documentService, isEnabled]);

	return <img alt="logo" className="logo" src={isEnabled ? logo : logoUrl} />;
}
